const $inject = ['$filter', 'moment', 'settingsService', 'cartService'];

const travelFiltersService = function travelFiltersService($filter, moment, settingsService, cartService) {
  let service = {};

  const TIME_FORMAT = $filter('translate')('dates.TimeFormatLong');

  service.getFilters = getFilters;

  function getFilters() {
    return new Filters();
  }

  function Filters() {
    this.clean = {
      filterName: 'travelCleanFilter',
      settings: {
        isActive: () => true
      }
    };

    this.cartItems = {
      label: 'Cart',
      filterName: 'cartItemsFilter',
      settings: {
        cartItems: cartService.items,
        resultsIndex: 0,
        isActive: function () {
          return this.cartItems.length;
        }
      }
    };

    this.cheapestFare = {
      name: 'cheapestFare',
      filterName: 'cheapestFareFilter',
      clearActiveFilters: true,
      settings: {
        enabled: false,
        isActive: function() {
          return this.enabled;
        }
      }
    };

    this.timeRange = {
      filterName: 'timeOfDayFilter',
      settings: {
        reference: 'DepartureTime',
        start: 0,
        end: 1440,
        val: 'All',
        isActive: function() {
          return this.start > 0 || this.end < 1440;
        }
      }
    };

    this.priceRange = {
      label: 'Price',
      labelSuffix: `(${settingsService.settings.Currency.Code})`,
      filterName: 'travelPriceRangeFilter',
      isResultsFilter: true,
      settings: {
        type: 'range',
        reference: 'Price',
        defaultMax: 0,
        defaultMin: 0,
        maxValue: 0,
        minValue: 0,
        step: 1,
        translateFunc: function (value) {
          return $filter('currency')(value, '', 0);
        },
        isActive: function () {
          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
        },
        clear: function () {
          this.minValue = this.defaultMin;
          this.maxValue = this.defaultMax;
        }
      }
    };

    this.departureTimeRange = {
      label: 'Departure Time',
      filterName: 'travelTimeFilter',
      isResultsFilter: true,
      settings: {
        type: 'range',
        reference: 'DepartureTime',
        defaultMax: 1439,
        defaultMin: 0,
        maxValue: 1439,
        minValue: 0,
        step: 5,
        translateFunc: translateMinutesTime,
        isActive: function () {
          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
        },
        clear: function () {
          this.minValue = this.defaultMin;
          this.maxValue = this.defaultMax;
        }
      }
    };

    this.arrivalTimeRange = {
      label: 'Arrival Time',
      filterName: 'travelTimeFilter',
      isResultsFilter: true,
      settings: {
        type: 'range',
        reference: 'ArrivalTime',
        defaultMax: 1439,
        defaultMin: 0,
        maxValue: 1439,
        minValue: 0,
        step: 5,
        translateFunc: translateMinutesTime,
        isActive: function () {
          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
        },
        clear: function () {
          this.minValue = this.defaultMin;
          this.maxValue = this.defaultMax;
        }
      }
    };

    this.carrier = {
      label: 'Airlines',
      filterName: 'anyInCollectionFilter',
      isResultsFilter: true,
      settings: {
        type: 'multiSelect',
        reference: 'Carrier',
        selectedReference: 'value',
        options: [],
        selected: [],
        isActive: function () {
          return this.selected.length > 0;
        },
        clear: function () {
          this.selected = [];
        }
      }
    };

    this.stopsOptionList = {
      label: 'Stops',
      filterName: 'anyInArrayFilter',
      isResultsFilter: true,
      settings: {
        type: 'checkboxGroup',
        reference: 'Stops',
        options: [
          {
            value: 0,
            label: 'Nonstop',
            id: 'Stops-0'
          },
          {
            value: 1,
            label: '1 stop',
            id: 'Stops-1'
          },
          {
            value: 2,
            label: '2 stops',
            id: 'Stops-2'
          },
          {
            value: 3,
            label: '3 stops',
            id: 'Stops-3'
          }
        ],
        selected: [],
        isActive: function () {
          return this.selected.length;
        },
        clear: function () {
          this.selected = []
        }
      }
    };

    this.displayFare = {
      filterName: 'travelDisplayFareFilter',
      settings: {
        isActive: () => true
      }
    };
  }

  function translateMinutesTime(mins) {
    let hours = Math.floor(mins / 60);
    let minutes = mins % 60;

    if(hours === 24 && minutes === 0) {
      hours = 23;
      minutes = 59;
    }

    if (minutes < 10) {
      minutes = '0' + minutes;
    }

    return moment(`${hours}:${minutes}`, 'H:mm').format(TIME_FORMAT);
  }

  return service;
};

travelFiltersService.$inject = $inject;

export default travelFiltersService;




// WEBPACK FOOTER //
// ./src/services/travelFiltersService.js